module.exports = __webpack_public_path__ + "img/f7a5c2177e8f42a296a7e1c511cabf8d.png";